<template>
  <div class="row custom_phone_country_select">
    <div class="col-md-6">
      <div v-if="!editClient">
        <p>{{ client.name }}</p>
        <p>{{ client.email }}</p>
        <div v-for="phone in client.phones">
          <p>{{ phone.phone }}</p>
          <p v-if="phone.comment">{{ phone.comment }}</p>
        </div>
      </div>
      <div v-if="editClient">
        <div class="mb-2">
          <input type="text" :disabled="!allowToChangeClientData" v-model="client.name" placeholder="ФИО клиента"
                 class="form-control">
          <input type="text" :disabled="!allowToChangeClientData" v-model="client.comment"
                 placeholder="комментарий к клиенту" class="form-control">
          <input type="text" :disabled="!allowToChangeClientData" v-model="client.email" placeholder="email"
                 class="form-control">
        </div>
        <div class="alert alert-info p-2 mb-2 mt-1" v-if="$editNewOrder.phone_call_id">
          <p><i class="icon-fa icon-fa-info-circle"/> Текущий телефонный звонок <strong
            v-if="$editNewOrder.phone">{{ $editNewOrder.phone }}</strong></p>
          <p>привязан к текущей заявке</p>
        </div>
        <div class="phones">
          <div v-for="(phone, index) in phones" class="mb-2">
            <div class="flex">
              <VuePhoneNumberInput
                class="phone_input"
                v-model="phone.phone"
                :loader="phoneSearch[index]"
                @update="(e) => phoneValidate(e, index)"
                :translations="{
                  countrySelectorLabel: 'Код страны',
                  countrySelectorError: 'Верный телефон',
                  phoneNumberLabel: 'Номер телефона',
                  example: 'Пример :'
              }"
                :only-countries="['RU','BY', 'UA', 'KG', 'KZ', 'AM']"
                :default-country-code="phone.country || 'RU'"
              />
              <BlackListButton
                v-if="phone && phone.valid && phone.phone"
                :phone="phone"
                :blackList="blackList[index]"
              />
              <MakeCall v-if="phone.valid" :phone="phone" :order="$editNewOrder"/>
            </div>
            <div class="flex">
              <input type="text" v-model="phone.comment" placeholder="Комментарий к телефону" class="form-control">
              <button v-if="index > 0" @click="removePhone(index)" class="btn btn-outline-danger no-wrap"><i
                class="icon-fa icon-fa-trash-o" aria-hidden="true"></i></button>
            </div>
            <PhoneCallsHistory
              :phone="phone"
              :orderId="$editNewOrder.id"
            />
          </div>
          <div class="text-right">
            <button @click="addNewPhoneLine" class="btn btn-sm btn-outline-info">добавить телефон</button>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="alert alert-warning" v-if="question">
        <div v-if="question.type === 'phoneOccupied' || question.type === 'nameDiff'">
          <h6>Телефон <strong>{{ mixinPrintPhone(question.client.full_phone) }}</strong> принадлежит клиенту:</h6>
          <p>{{ question.client.client.name }}</p>
          <div>
            <hr>
            <button @click="updateQuestion('rejectClient')" class="btn btn-warning">Отвязать телефон от клиента <strong>{{
                question.client.client.name
              }}</strong></button>
            <button @click="updateQuestion('acceptClient')" class="btn btn-info">Использовать клиента
              <strong>{{ question.client.client.name }}</strong> в заявке
            </button>
          </div>
        </div>
      </div>
      <div v-if="addressCases && addressCases.length">
        <p class="mb-0"><i class="icon-blue icon-fa icon-fa-motorcycle"></i> Использовались адреса (<strong>{{
            addressCases.length
          }}</strong>):</p>
        <div v-bind:class="{'address_list': true, 'short_address_list': !showAllAddresses || addressCases.length > 4}">
          <p v-for="a in addressCases">{{ a }}</p>
        </div>
        <hr class="m-0 mb-1">
        <!--        <a href="#" @click.prevent="showAllAddresses = !showAllAddresses">показать</a>-->
      </div>
      <div>
        <i class="icon-blue icon-fa icon-fa-calendar-check-o"></i> История заявок
        <div v-for="phone in Object.keys(historyOrders)">
          <p class="mb-1">телефон: <strong>{{ phone }}</strong> всего заявок (<strong>{{
              historyOrders[phone].orders.length
            }}</strong>)
            <a v-if="historyOrders[phone].orders.length > 3" href="#" @click.prevent="showOrders(phone)">показать
              все</a>
          </p>
          <div class="history_orders">
            <table class="table table-sm table-striped mt-0">
              <tbody>
              <template v-for="(o, index) in historyOrders[phone].orders" v-if="index < 3 || historyOrders[phone].open">
                <tr>
                  <td>
                    <p class="mb-0">{{ o.project_label }}
                      <span v-if="o.report_date || o.created_at">({{
                          printDate((o.report_date || o.created_at), 'DD.MM.YYYY')
                        }})</span></p>
                    <span
                      v-bind:class="{
                      'badge badge-warning': o.status < 0,
                      'badge badge-info': (o.status == 1 || o.status == 2 || o.status === 8),
                      'badge badge-dark': o.status > 100,
                      'badge badge-success': o.status == 3,
                      'badge badge-dark': o.status == 0 || o.status == 9999,
                    }">{{
                        o.id
                      }}<br>{{ o.status_label }}</span>
                  </td>
                  <td>{{ o.reject_comment }}</td>
                  <td>
                    <div class="drugs_list">
                      <p>Клиент: <strong>{{ o.client_name }}</strong></p>
                      <p v-for="detail in o.details">{{ detail.new_drug.title }}</p>
                    </div>
                  </td>
                  <td class="drugs_list">
                    <p class="mb-0">{{ o.formated_report_date }}</p>
                    <p class="mb-0"><strong>{{ o.price }} <span v-if="o.delivery_price">({{ o.delivery_price }})</span></strong>
                      руб</p>
                  </td>
                </tr>
              </template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import VuePhoneNumberInput from 'vue-phone-number-input'
import 'vue-phone-number-input/dist/vue-phone-number-input.css'
import MakeCall from '@/components/orders/telephony/MakeCall'
import api from '@/api'
import BlackListButton from './BlackListButton'
import PhoneCallsHistory from '@/components/orders/telephony/PhoneCallsHistory'

export default {
  props: ['selectedClient', 'selectedPhones'],
  components: {
    VuePhoneNumberInput,
    BlackListButton,
    MakeCall,
    PhoneCallsHistory,
  },
  data() {
    return {
      addressCases: [],
      showAllAddresses: false,
      editClient: false,
      emptyClient: true,
      question: false,
      allowToChangeClientData: false,
      notValidPhone: null,
      phoneSearch: {
        0: false
      },
      historyOrders: {},
      client: {
        id: null,
        name: null,
        comment: null,
        email: null,
      },
      blackList: {},
      phones: [
        {
          phone: null,
          full_phone: null,
          comment: null,
          valid: false,
        }
      ]
    }
  },
  watch: {
    'client': {
      handler: function (val, oldVal) {
        this.updateClientInOrder();
      },
      deep: true
    },
  },
  computed: {
    $editNewOrder() {
      return this.$store.getters['orders/editNewOrder']
    },
  },
  mounted() {
    if (!this.selectedClient) {
      this.initiateClient();
    } else {
      if (this.selectedClient.id) {
        this.client = {...this.selectedClient}
        this.editClient = true
        this.allowToChangeClientData = true
      }
      if (this.selectedPhones && this.selectedPhones.length) {
        let phoneSearch = {}
        this.phones = this.selectedPhones.reduce((acc, p, i) => {
          acc.push({
            ...p,
            comment: p.phone.comments && p.phone.comments[0].comment || null,
            full_phone: p.phone.phone,
            phone: p.phone.phone,
            country: p.phone.country,
            valid: true,
          })
          phoneSearch[i] = false
          return acc
        }, [])
        this.phoneSearch = phoneSearch
      }
    }
  },
  methods: {
    updateClientInOrder() {
      this.$store.dispatch('orders/setEditNewOrder', {
        ...this.$editNewOrder,
        client: {...this.client, phones: this.phones}
      });
    },
    resetClient() {
      this.historyOrders = {};
      this.client = {
        id: null,
        name: null,
        comment: null,
        email: null,
      };
      this.blackList = {};
      this.phones = [
        {
          phone: null,
          full_phone: null,
          comment: null,
          valid: false,
        }
      ];
      this.addressCases = [];
    },
    initiateClient() {
      this.editClient = true
      if (this.$editNewOrder.client_name) {
        this.client.name = this.$editNewOrder.client_name
      }
      this.client.email = this.$editNewOrder.extra_options?.email
      // console.log(this.selectedPhones, this.$editNewOrder.phone);
      if (this.selectedPhones && this.selectedPhones.length) {
        let phoneSearch = {}
        this.phones = this.selectedPhones.reduce((acc, p, i) => {
          acc.push({
            ...p,
            comment: p.comment || null,
            full_phone: p.phone.phone,
            phone: p.phone.phone,
            country: p.phone.country,
            valid: true,
          })
          phoneSearch[i] = false
          return acc
        }, [])
        this.phoneSearch = phoneSearch
      } else {
        this.phones[0].phone = this.$editNewOrder.phone
      }
    },
    showOrders(index = false) {
      Object.keys(this.historyOrders).forEach((p) => {
        this.historyOrders[p].open = false
      })
      if (!index) {
        this.historyOrders = {...this.historyOrders}
      } else {
        this.historyOrders[index].open = true
      }
    },
    removePhone(index) {
      delete this.phones[index]
      this.phones = this.phones.filter((p) => p)
      this.clearHistory()
    },
    updateQuestion(action) {
      switch (action) {
        case 'acceptClient':
          this.client = {...this.question.client.client}
          break
        case 'rejectClient':
          break
      }
      this.question = false
    },
    addNewPhoneLine() {
      this.phones.push({
        phone: null,
        comment: null,
        valid: false,
      })
      this.$set(this.phoneSearch, (this.phones.length - 1), false)
    },
    async saveClient() {

    },
    clearHistory() {
      Object.keys(this.historyOrders).forEach((p) => {
        if (this.phones.findIndex((sp) => sp.search_phone === p) === -1) {
          delete this.historyOrders[p]
        }
      })
    },
    async phoneValidate(e, index, hard = false) {
      // console.log('validate phone', e, index, hard)
      if (!e.e164) return;
      this.phones[index].valid = false
      this.phones[index].id = null
      if (this.question) {
        toastr['warning']('Для дальнейшего изменения клиента требуется решить конфликт')
        return
      }
      if (!hard && !e.isValid) {
        // console.log('return 1')
        return
      }
      this.phones[index].valid = true
      const anyPhonesInValidating = Object.values(this.phoneSearch).find((s) => s)
      if (anyPhonesInValidating) {
        // console.log('return 2')
        // return
      }
      this.phoneSearch[index] = true
      let {data} = await api.post('/clients/validateClientPhone', {phone: e.e164})
      if (data.success) {
        this.question = false
        this.phones[index].full_phone = e.e164
        this.phones[index].search_phone = data.record.phone
        // this.phones[index].comment = data.record && data.record.comments ? data.record.comments[data.record.comments.length - 1].comment : null
        this.blackList[index] = data.blackList
        if (!this.client.name && data.client && data.client.name) {
          this.client.name = data.client.name
          this.client.email = data.client.email
        }
        this.allowToChangeClientData = true
        this.clearHistory()
        let addressCases = []
        if (hard) {
          this.phones[index].phone = e.e164
        }
        if (data.orders && data.orders.length) {
          addressCases = data.orders.reduce((acc, o) => {
            if (o && o.address && !acc.includes(o.address)) {
              acc.push(o.address)
            }
            return acc
          }, [])
          this.addressCases = addressCases
          this.historyOrders[data.record.phone] = {orders: data.orders, open: false}
          this.showOrders(false)
        }
      } else {
        toastr['warning'](data.message || 'Ошибка валидации телефона')
      }
      this.phoneSearch[index] = false
    }
  }
}

</script>

<style scoped>
.drugs_list {
  font-size: 12px;
}

.drugs_list p {
  margin-bottom: 0;
}

.address_list p {
  margin-bottom: 0;
}

.short_address_list {
  max-height: 100px;
  overflow: auto;
}

.history_orders {
  max-height: 200px;
  overflow: auto;
}

.phone_input {
  flex: 1;
}

.no-wrap {
  white-space: nowrap;
}

.no-wrap i {
  text-align: center;
}

.history_orders table td {
  padding: 1px 5px;
}
</style>

<style>
.custom_phone_country_select .country-selector__list {
  z-index: 1;
}
</style>
